<template>
  <section class="s-button">
    <!-- 按钮 -->
    <div
      class="btn"
      :class="{
      solidBtn: isSolid, emptyBtn: !isSolid,
      primary: theme === 'primary', default: theme === 'default', danger: theme === 'danger',
      large: size === 'large', normal: size === 'normal', small: size === 'small'
      }" :style="btnStyle">
      <h1 style="position: relative; z-index: 9999;"><slot></slot></h1>
      <div class="mask" v-if="isSolid"></div>

      </div>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 超级按钮组件
  * @description 超级按钮组件
  * @author ah
  *****************************************
  theme           String              主题(primary/default/danger)
  isSolid         Boolean             是否实心
  text            String              按钮文字
  size            String              按钮大小(large/normal/small)
  *****************************************/
  name: 's-button',
  components: {},
  props: {
    theme: {
      type: String,
      default () {
        return 'danger'
      }
    },
    isSolid: {
      type: Boolean,
      default () {
        return true
      }
    },
    text: {
      type: String,
      required: true,
      default () {
        return '未定义'
      }
    },
    size: {
      type: String,
      default () {
        return 'normal'
      }
    }
  },
  data () {
    return {
      btnStyle: {
        border: `1px solid ${this.themeHandle}`,
        backgroundColor: this.themeHandle
      }
    }
  },
  computed: {
    themeHandle () {
      if (this.theme === 'primary') {
        return '#276BEE'
      } else if (this.theme === 'default') {
        return 'grey'
      } else {
        return 'red'
      }
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.s-button{
  .btn{
    position: relative;
    width: 100%;
    text-align: center;
    border-radius: 3px;
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid transparent;
    transition: all 0.3s;
    margin-bottom: 5px;

    &:hover .mask{
      opacity: 1;
    }

    .mask{
      width: 100%;
      position: absolute;
      opacity: 0;
      left: 0;
      transition: all 0.3s;
      background: rgba(0,0,0,.2);
      top: 0;
      height: 100%;
      min-width: 100%;
    }
  }
  // ---------------------------theme
  .primary{
    color:#fff;
    background-color: #276BEE;
  }
  .default{
    color:#000;
    background-color: grey;
  }
  .danger{
    color:#fff;
    background-color: red;
  }

  // ---------------------------size
  .large{
    font-size: 0.1rem;
    // font-size: 18px;
    line-height: 0.25rem;
    // line-height: 50px;
  }
  .normal{
    // font-size: 14px;
    // line-height: 35px;
    font-size: 0.07rem;
    line-height: 0.18rem;
  }
  .small{
    // font-size: 12px;
    // line-height: 20px;
    font-size: 0.07rem;
    line-height: 0.18rem;
  }

  // ---------------------------isSolid
  .solidBtn{

    &:hover{
      // background-color: transparent;
    }
  }
  .emptyBtn{
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SBtn.vue